
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function StepByStepModal(props) {

    const [showModal, setShowModal] = useState(false);
    const [stepByStep, setStepByStep] = useState([]);

    async function recipeAnalyzedInstructions() {
        let url =`${process.env.REACT_APP_SERVER_URL}/recipeAnalyzedInstructions?id=${props.id}`;
        const response = await fetch(url, {
            method: "GET",
        });
        const data = await response.json();
        setStepByStep(data);
    }

    async function renderModalData(params) {
        recipeAnalyzedInstructions();
        setShowModal(true);
    }

    return (
        <>
            <Button onClick={renderModalData}>
                Show Steps
            </Button>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Steps</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        stepByStep.length > 0 && stepByStep[0].steps.map((step, index) => (
                            <div key={index}>
                                <h4>Step {step.number}</h4>
                                <p>{step.step}</p>
                            </div>
                        ))
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Done
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}





